<template>
    <div class="memorandum_action " v-if="!is_mem_load">
        
        <div class="bd-callout bd-callout-info" v-if="empty_right">
            <b-card-group deck>
                <b-card text-variant="black" title="У Вас недостатньо прав для обробки документу"
                        class="text-center shadow-0">
                    <b-card-text>
                        На даний момент Ви не можете обробляти документ.
                    </b-card-text>
                </b-card>
            </b-card-group>
        </div>
        
        <!-- init rights -->
        <div class="adjust_block_work" v-if="cur_right === 'init_user_restart'">
            <b-row>
                <b-col v-if="hasBlackList" class="pt-3 mt-3 pb-3 mb-3" >
                    Контрагент знаходиться в чорному списку, за роз'ясненнями звертатися до керівництва ФЕБ
                </b-col>
                
                
                <b-col sm="12" v-else>
                    <fileloader key="file_loader_mem_inside_work"
                                doc_type="memorandum"
                                :doc_id="-1"
                                v-bind:trigger_load="file_triger"
                                v-bind:can_del="true">
                    </fileloader>
                </b-col>
            </b-row>
            
            <b-col sm="3" class="pt-3 mt-3 pb-3 mb-3" v-if="!hasBlackList">
                <b-button :disabled="is_locked_button" block variant="warning" size="xl"
                          class=" fs-xl  text-white "
                          @click="agree_action('init_user_restart')">
                    <span class="fal fa-exclamation-triangle mr-1"></span>
                    Перезапустити
                </b-button>
            </b-col>
        </div>
        
        <div class="init_close button_margin" v-if="cur_right === 'draft_init'">
            <b-row>
                <b-col v-if="hasBlackList" class="pt-3 mt-3 pb-3 mb-3" >
                    Контрагент знаходиться в чорному списку, за роз'ясненнями звертатися до керівництва ФЕБ
                </b-col>
                
                <b-col v-else sm="3" class="pt-3 mt-3 pb-3 mb-3">
                    <b-button :disabled="is_locked_button" block variant="success"
                              @click="agree_action('draft_init')">Запустити в роботу
                    </b-button>
                </b-col>
            </b-row>
        </div>
        
        <div class="init_close" v-if="cur_right === 'init_user_close'">
            <b-row>
                <b-col sm="12">
                    <fileloader key="file_loader_mem"
                                doc_type="memorandum"
                                :doc_id="-1"
                                v-bind:trigger_load="file_triger"
                                v-bind:can_del="true">
                    </fileloader>
                </b-col>
                
                <b-col sm="12">
                    <vue-editor :editor-toolbar="editor_rules" id="d_ini_acc" v-model="form.text"></vue-editor>
                </b-col>
                
                <b-col sm="3" class="pt-3 mt-3 pb-3 mb-3">
                    <b-button :disabled="is_locked_button" block variant="success" class="lhx2"
                              @click="agree_action('init_close')">В Архів
                    </b-button>
                </b-col>
            </b-row>
        </div>
        
        
        <!-- ADJUST BLOCK -->
        <div class="adjust_block_work" v-if="cur_right === 'adjust_user'">
            <b-row>
                <b-col sm="12">
                    <fileloader key="file_loader_mem"
                                doc_type="memorandum"
                                :doc_id="-1"
                                v-bind:trigger_load="file_triger"
                                v-bind:can_del="true">
                    </fileloader>
                </b-col>
            </b-row>
            <b-row class="mem_create_row">
                <b-col sm="3" class="mh170">
                    <div v-if="hasBlackList" class="h-100 d-flex flex-column" >
                        Контрагент знаходиться в чорному списку, за роз'ясненнями звертатися до керівництва ФЕБ
                    </div>
                    
                    <div v-else class="h-100 d-flex flex-column">
                        <b-button :disabled="is_locked_button" block class="mb-auto fs-xl lhx2" variant="primary"
                                  @click="agree_action('adjust')">
                            <span class="fal fa-check mr-1"></span>
                            Погоджую
                        </b-button>
                        
                        <b-button :disabled="is_locked_button" block class="lhx2 fs-xl" variant="danger"
                                  @click="dis_agree_action('adjust')">
                            <span class="fal fa-exclamation-triangle mr-1"></span>
                            Не погоджую
                        </b-button>
                    </div>
                </b-col>
                
                <b-col sm="9">
                    <vue-editor :editor-toolbar="editor_rules" id="result" v-model="form.text"></vue-editor>
                </b-col>
            </b-row>
        </div>
        
        
        <!-- Recipient_block -->
        <div class="recipient_block" v-if="cur_right === 'recipient_user'">
            <b-row>
                <b-col sm="12">
                    <fileloader key="file_loader_mem"
                                doc_type="memorandum"
                                :doc_id="-1"
                                v-bind:trigger_load="file_triger"
                                v-bind:can_del="true">
                    </fileloader>
                </b-col>
            </b-row>
            <b-row class="mem_create_row">
                <b-col sm="3" class="mh170">
                    <div class="h-100 d-flex flex-column">
                        <b-button :disabled="is_locked_button" block class="mb-auto lhx2 fs-xl" variant="success"
                                  @click="agree_action('recipient')">Затвердити
                        </b-button>
                        
                        <b-button :disabled="is_locked_button" block class="mb-auto lhx2 fs-xl" variant="primary"
                                  @click="edit_adjust()">Додати погодження
                        </b-button>
                        
                        <b-button :disabled="is_locked_button" block class="lhx2 fs-xl" variant="danger"
                                  @click="dis_agree_action('recipient')">Вiдхилити
                        </b-button>
                    </div>
                </b-col>
                
                <b-col sm="9">
                    <vue-editor :editor-toolbar="editor_rules" id="result_rec" v-model="form.text"></vue-editor>
                </b-col>
            </b-row>
        </div>
        
        <!-- ISP User -->
        <div class="isp_block_accept" v-if="cur_right === 'isp_user_accept'">
            <b-row>
                <b-col sm="12">
                    <fileloader key="file_loader_mem"
                                doc_type="memorandum"
                                :doc_id="-1"
                                v-bind:trigger_load="file_triger"
                                v-bind:can_del="true">
                    </fileloader>
                </b-col>
            </b-row>
            
            <b-row class="mem_create_row">
                <b-col sm="3" class="mh170">
                    <date-picker
                        value-type="format"
                        v-model="form.date_to" :lang="d_lang" confirm
                        :first-day-of-week="1">
                    </date-picker>
                    
                    <div class="add user" @click="delegate">
                        <i title="" class="fa add_user fa-plus-square" data-type="delegate_users"></i>
                        <span>Делегування</span>
                    </div>
                    
                    <div class="users_delegate">
                        <div class="user_list u_list" v-if="form.users.length > 0">
                            <div class="isp_list">
                                <user_block
                                    class="mb-1"
                                    v-for="(item) in form.users"
                                    :key="item.id"
                                    v-bind:user="item">
                                </user_block>
                            </div>
                        </div>
                    </div>
                </b-col>
                
                <b-col sm="9">
                    <vue-editor :editor-toolbar="editor_rules" id="result_isp_acc" v-model="form.text"></vue-editor>
                </b-col>
            </b-row>
            
            <b-row class="mem_create_row ">
                <b-col sm="4" lg="4" xl="3" xs="12" class="offset-lg-8 offset-xl-9 offset-sm-8 text-right pt-4">
                    <b-button :disabled="is_locked_button" block variant="success"
                              class="mb-auto fs-xl p-3 text-white mt-2"
                              @click="agree_action('isp_accept')">Прийняв в роботу
                    </b-button>
                    
                    <b-button :disabled="is_locked_button" block variant="danger" v-if="can_arch" class="fs-xl p-3"
                              @click="agree_action('store_isp_arch')">В архів
                    </b-button>
                </b-col>
            </b-row>
        </div>
        
        <div class="isp_block_work" v-if="cur_right === 'isp_user_work'">
            <b-row>
                <b-col sm="12">
                    <fileloader key="file_loader_mem"
                                doc_type="memorandum"
                                :doc_id="-1"
                                v-bind:trigger_load="file_triger"
                                v-bind:can_del="true">
                    </fileloader>
                </b-col>
                
                <b-col sm="12">
                    <vue-editor :editor-toolbar="editor_rules" id="d_isp_acc" v-model="form.text"></vue-editor>
                </b-col>
                
                <b-col sm="3" class="pt-3 mt-3 pb-3 mb-3">
                    <b-button :disabled="is_locked_button" block variant="success" class="lhx2"
                              @click="agree_action('isp_work_end')">Виконав
                    </b-button>
                </b-col>
            </b-row>
        </div>
        
        <div class="isp_block_work" v-if="cur_right === 'is_user_work_random'">
            <b-row>
                <b-col sm="12">
                    <fileloader key="file_loader_mem"
                                doc_type="memorandum"
                                :doc_id="-1"
                                v-bind:trigger_load="file_triger"
                                v-bind:can_del="true">
                    </fileloader>
                </b-col>
                
                <b-col sm="12">
                    <vue-editor :editor-toolbar="editor_rules" id="d_isp_acc_r" v-model="form.text"></vue-editor>
                </b-col>
            
            </b-row>
            
            <h1 class="title text-center pt-5 pb-5 mt-5">
                Коли виконавець виконує службову, то повинен заповнити такі реквізити:
            </h1>
            
            <b-row class="fields_randm mt-2" v-if="random_adjust_data.length > 0">
                <b-col sm="6">
                    <div class="isp_fields mt-3" v-for="(field,idx) in this.random_adjust_data">
                        <b-form-text :id="'help_' + field.type + field.id">
                            {{field.name}}
                            <span class="color-danger-500" v-if="field.required == 1"> * </span>
                        </b-form-text>
                        
                        <b-form-input
                            type="text"
                            class="fs-xl"
                            v-if="field.type == 'string_input'"
                            :state="is_valid_field(field)"
                            v-model="field.value"
                            :id="field.type + field.id"
                            size="sm" >
                        </b-form-input>
                        
                        
                        <date-picker v-if="field.type == 'date'"
                                     value-type="format"
                                     :key="'dt_' + field.id"
                                     v-model="field.value"
                                     :lang="d_lang"
                                     :first-day-of-week="1"
                                     confirm >
                        </date-picker>
                    
                    </div>
                </b-col>
            </b-row>
            
            <b-row>
                <b-col sm="3" class="pt-3 mt-3 pb-3 mb-3">
                    <b-button :disabled="is_locked_button" block variant="success" class="lhx2"
                              @click="agree_action('isp_random_work_end')">Виконав
                    </b-button>
                </b-col>
            </b-row>
        
        </div>
        
        
        <!-- delegate block -->
        <div class="delegate_block_accept" v-if="delegate_operation">
            <b-row>
                <b-col sm="12">
                    <fileloader key="file_loader_mem"
                                doc_type="memorandum"
                                :doc_id="-1"
                                v-bind:trigger_load="file_triger"
                                v-bind:can_del="true">
                    </fileloader>
                </b-col>
                
                <b-col sm="3">
                    <date-picker v-if="cur_right === 'delegate_user_accept'"
                                 value-type="format"
                                 v-model="form.date_to"
                                 :lang="d_lang"
                                 :first-day-of-week="1"
                                 confirm>
                    </date-picker>
                    
                    <b-button :disabled="is_locked_button" v-else block variant="success" class="lhx2"
                              @click="agree_action('delegate_work_end')">Виконав
                    </b-button>
                
                </b-col>
                
                <b-col sm="9">
                    <vue-editor :editor-toolbar="editor_rules" id="delegate_isp_acc" v-model="form.text"></vue-editor>
                </b-col>
            </b-row>
            
            <b-row class="mem_create_row" v-if="cur_right === 'delegate_user_accept'">
                <b-col sm="3">
                    <b-button :disabled="is_locked_button" block variant="success" class="lhx2"
                              @click="agree_action('delegate_accept')">Прийняв в роботу
                    </b-button>
                </b-col>
            </b-row>
        </div>
        
        <!-- random -->
        <div class="adjust_block_work" v-if="is_random_adjust_over">
            <b-row class="mem_create_row">
                <b-col sm="3" class="mh170">
                    <div class="h-100 d-flex flex-column">
                        <b-button :disabled="is_locked_button" block class="mb-auto fs-xl lhx2" variant="primary"
                                  @click="agree_action('random_adjust_user')">
                            <span class="fal fa-check mr-1"></span>
                            Погоджую
                        </b-button>
                        
                        <b-button :disabled="is_locked_button" block class="lhx2 fs-xl" variant="danger"
                                  @click="dis_agree_action('random_adjust_user')">Вiдхилити
                        </b-button>
                    </div>
                </b-col>
                <b-col sm="9">
                    <div class="panel-tag">
                        При погоджені, службова автоматично буде відправлена на затвердження. Якщо відмова - то автоматично буде запропонована іншим учасникам.
                    </div>
                    
                    <div class="time_left">
                        <flip-countdown
                            :labels="flip_label"
                            :deadline=this.random_adjust_data.deadLine :showDays="true">
                            @timeElapsed="timeElapsedHandler"
                        </flip-countdown>
                    </div>
                    
                    <div class="">
                        <vue-editor :editor-toolbar="editor_rules" id="resultы" v-model="form.text"></vue-editor>
                    </div>
                
                </b-col>
            </b-row>
        </div>
        
        
        
        <!--
       
       
        <div class="adjust_block_work" v-if="cur_right === 'random_adjust_force1'">
            <b-row class="mem_create_row">
                <b-col sm="3" class="mh170">
                    <div class="h-100 d-flex flex-column">
                        <b-button :disabled="is_locked_button" block class="mb-auto fs-xl lhx2" variant="primary"
                                  @click="agree_action('random_adjust_force')">
                            <span class="fal fa-check mr-1"></span>
                            Позачергово
                        </b-button>
                    </div>
                </b-col>
                <b-col sm="9">
                    <div class="panel-tag">
                        Стати в чергу на придбання, у випадку якщо к-ть ітерацій згідно рандому буде вичерпано. Діє правило - хто перший того і тапки.
                    </div>
                </b-col>
            </b-row>
        </div>
        
       
        
        
        -->
    </div>


</template>

<script>
import {VueEditor} from "vue2-editor";
import DatePicker from 'vue2-datepicker';
import FlipCountdown from 'vue2-flip-countdown';
import {createHelpers} from 'vuex-map-fields';
import user_block from "../../../../../../shared/user/user_block/user_block.vue";
import {mapGetters} from "vuex";
import fileloader from "../../../../../../shared/file_loader/fileloader.vue";

export default {
    name: "tab_work",
    
    props: {
        doc_id: {
            type: Number,
            required: true
        },
        
        user_id: {
            type: String,
            default: '',
        },
        
        file_triger: {
            type: String,
            default: "mem_file_worker",
        }
    },
    
    components: {
        VueEditor,
        DatePicker,
        user_block,
        FlipCountdown,
        fileloader
    },
    data() {
        return {
            flip_label : {
                days : "дні",
                hours: 'годин',
                minutes: 'хвилин',
                seconds: 'секунд',
            },
            
            form: {
                text: '',
                status: -1,
                date_to: '',
                mem_files: [],
                users: [],
                type: '',
                doc_id: this.doc_id,
            },
            
            is_locked_button: false,
            
            random_adjust_data: {
                "is_over": true,
                "deadLine": "",
            },
            cur_right: '',
            is_init: false,
            
            editor_rules: [
                ["bold", "italic", "underline", "link"],
                [{align: "center"}, {align: "right"}, {align: "justify"}],
                [{list: "ordered"}, {list: "bullet"}, {list: "check"}],
            ],
        }
    },
    created() {
        this.getCurrentRight();
        
        //file loaded
        EventBus.$on(this.file_triger, e => {
            console.log('FILE_ACTION', e);
            this.work_files(e);
        });
        
        EventBus.$on('refresh_tabs', e => {
            console.log('REFRESH_CALLED', e);
            this.refresh_tab(e);
        });
        
        EventBus.$on('selected_users', e => {
            if (e !== undefined && e.uniq === this.delegate_uniq) {
                this.delegate_add(e.users);
            }
        });
        
    },
    
    methods: {
        
        is_valid_field(field) {
            if(field.required === '1') {
                if(field.type == 'string_input') {
                    return field.value.toString().length  > 0;
                }
                return false;
            }
            
            return true;
        },
        
        edit_adjust() {
            EventBus.$emit('load_users_adjust', {
                doc_id: this.doc_id,
                cur_type: "recipient_edit"
            });
        },
        
        timeElapsedHandler () {
            self.getCurrentRight();
        },
        
        delegate() {
            EventBus.$emit('load_users_filter', {uniq: this.delegate_uniq});
        },
        
        delegate_add(users) {
            this.form.users = users;
        },
        
        refresh_tab(e) {
            if (e.tabs.length > 0) {
                let self = this;
                e.tabs.forEach(tab => {
                    if(tab === this.$options.name) {
                        self.getCurrentRight();
                    }
                })
            }
        },
        
        agree_action(type) {
            if (type !== 'isp_accept') {
                this.form.status = 1;
            }
            this.form.type = type;
            
            if(type == 'random_adjust_user') {
                const is_ok = confirm_imc('Ви впевнені, що хочете затвердити службову');
                
                is_ok.then(res => {
                    this.lock_buttons(true).send_action();
                });
                return false;
            }
            else {
                this.lock_buttons(true).send_action();
            }
        },
        
        dis_agree_action(type) {
            this.form.status = 0;
            this.form.type = type;
            
            if(type == 'random_adjust_user') {
                const is_ok = confirm_imc('Ви впевнені, що хочете відхилити службову');
                is_ok.then(res => {
                    this.lock_buttons(true).send_action();
                });
            }
            else {
                this.lock_buttons(true).send_action();
            }
        },
        
        lock_buttons(flag) {
            this.is_locked_button = flag;
            return this;
        },
        
        async send_action() {
            this.show_loading(true);
            
            await api.patch('/memorandums/' +this.doc_id+ '/action/'+ this.form.type,{
                    'form': this.form,
                    'adv' : this.random_adjust_data
                }
            ).then(({data}) => {
                if (data.status === "operation_success") {
                    console.log(data);
                    this.show_loading(false);
                    EventBus.$emit('show_toast', {err: 'Збережено', type: "success", title: 'Обробка'})
                    window.location.href = "/inbox";
                   
                    EventBus.$emit('refresh_tabs', {
                        tabs: [
                            'tab_monitoring',
                            'tab_resolution',
                            'tab_files',
                            'tab_work'
                        ]
                    });
                    this.lock_buttons(false);
                }
            }).catch(err => {
                
                let header = err.response.headers;
                this.show_loading(false);
                
                if (header.err != undefined) {
                    EventBus.$emit('show_toast', {err: header.err, type: "danger", title: header.err_title});
                } else {
                    EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
                }
                this.lock_buttons(false);
            });
        },
        
        show_loading(flag) {
            this.$store.dispatch('memorandum_work_tabs/SET_MEM_LOAD_TAB', {
                type: this.$options.name,
                active: flag
            });
        },
        
        async getCurrentRight() {
            
            this.show_loading(true);
            await api.get('/memorandums/'+ this.doc_id +'/work/rights').then(({data}) => {
                    if (data.status === "operation_success") {
                        console.log('cur_rights', data);
                        this.cur_right = data.data.cur_right;
                        
                        try {
                            if (this.cur_right === 'random_adjust_user') {
                                this.random_adjust_data = data.data.extra;
                            }
                            
                            if (this.cur_right === 'is_user_work_random') {
                                this.random_adjust_data = data.data.extra;
                            }
                        } catch (e) {
                        
                        }
                        
                        this.show_loading(false);
                    }
                }).catch(err => {
                    this.show_loading(false);
                    EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
                });
        },
        
        work_files: function (res) {
            if (res !== undefined) {
                if (res.type === 'file_loaded') {
                    this.form.mem_files.push({
                        "id" : res.file_id,
                    });
                }
                
                if (res.type === 'file_deleted') {
                    console.log('remove_file',res);
                    for (let i = this.form.mem_files.length - 1; i >= 0; i -= 1) {
                        if (this.form.mem_files[i].id === parseInt(res.file_id)) {
                            this.form.mem_files.splice(i, 1);
                        }
                    }
                }
            }
        },
    },
    
    computed: {
        
        ...mapGetters({
            'memorandum': "memorandum_inside/getMemorandum",
            'is_mem_load': "memorandum_inside/is_load",
        }),
        
        hasBlackList() {
            try {
                if (this.memorandum.hasOwnProperty("addon")) {
                    if (this.memorandum.addon === 'bill') {
                        if (this.memorandum.hasOwnProperty("addon_data")) {
                            let stops = this.memorandum.addon_data.items.filter(item => {
                                return item.has_stop;
                            });
                            return stops.length > 0;
                        }
                    }
                }
            }
            catch (e) {
            
            }
            
            return false;
        },
        
        can_arch() {
            if (this.memorandum !== undefined) {
                if (this.memorandum.can_move_arch === 'yes') {
                    return this.form.users.length <= 0;
                }
            }
            return false;
        },
        
        is_random_adjust_over() {
            if(this.cur_right === 'random_adjust_user') {
                if (!this.random_adjust_data.is_over) {
                    return true;
                }
            }
            
            return false;
        },
        
        delegate_operation() {
            return this.cur_right === 'delegate_user_work' || this.cur_right === 'delegate_user_accept';
        },
        
        empty_right() {
            return this.cur_right === '' || this.cur_right === null || this.cur_right === 'init_user_canсeled';
        },
        
        d_lang() {
            return this.get_datepickLang();
        },
        
        delegate_uniq() {
            return 'delegate_' + this.doc_id;
        },
    },
    
  
    
   
    
    
}
</script>

<style scoped>
button[disabled] {
    opacity: 0.3;
}

button[disabled]:hover {
    opacity: 0.3;
}

.add.user {
    font-size: 26px;
    margin-top: 15px;
    cursor: pointer;
    text-align: left;
}

.lhx2 {
    line-height: 2;
}

.mh170 {
    min-height: 170px;
}

</style>
